import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { finalizeMediaUtil, initializeMediaUtil, uploadOnS3 } from "../../../utils/mediaUtils";

import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey } from "../../../api/api.keys";
import { CreateAlbum } from "../../../api/api.service";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../../constants/SubscriptionStatus";
import AudioSeriesForm from "./AudioSeriesForm";
import { APP_ROUTES } from "../../../helpers/routeHelpers";
import { showToast, SUCCESS } from "../../../utils/toastUtils";

const AddSeries = () => {
    const history = useHistory();
    const [isSeriesAudioAdd, setIsSeriesAudioAdd] = useState(false);
    let { useMutate } = useRequestProcessor();
    let { mutate, isLoading } = useMutate("", getKey(), (data) => CreateAlbum(data));

    const addAudioHandler = async (values) => {
        try {
            setIsSeriesAudioAdd(true);
            // Process regular fields
            const uploadResults = await Promise.all(
                Object.keys(values).map(async (fieldName) => {
                    const fieldData = values[fieldName];
                    if (fieldData?.file && fieldData?.exactFile) {
                        const mediaId = await handleMediaUpload(
                            fieldData?.file,
                            fieldData?.exactFile
                        );
                        return { fieldName, mediaId };
                    }
                    return null;
                })
            );
            // Attach mediaIds to form values
            uploadResults.forEach((result) => {
                if (result) {
                    const { fieldName, mediaId } = result;
                    values[fieldName].mediaId = mediaId;
                }
            });

            // Process session files
            for (const session of values.sessions) {
                if (session.sessionUploadAudio?.file) {
                    const mediaId = await handleMediaUpload(
                        session.sessionUploadAudio.file,
                        session.sessionUploadAudio.exactFile
                    );
                    session.sessionUploadAudio.mediaId = { id: mediaId };
                }
            }
            const formValues = {
                title: values.title,
                description: values.description,
                authorId: Number(values.author.value),
                categoryId: 2,
                labelIds: values.subCategory?.map((item) => item.value),
                narratorId: Number(values.narrator.value),
                thumbnailId: Number(values.uploadImage?.mediaId?.id), // Convert to number
                croppedThumbnailId: Number(values.uploadThumbnail?.mediaId?.id), // Convert to number

                tierType: SUBSCRIPTION_STATUS.FREEMIUM,

                audios: values.sessions.map((session) => ({
                    title: session.sessionTitle,
                    description: session.sessionDescription,
                    duration: Math.floor(Number(session.sessionUploadAudio?.duration)),
                    audioMediaId: Number(session.sessionUploadAudio?.mediaId?.id?.id),
                    tierType:
                        session.radioGroup ==
                        SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.FREEMIUM)
                            ? SUBSCRIPTION_STATUS.FREEMIUM
                            : SUBSCRIPTION_STATUS.PREMIUM,
                    completionMessage: session.sessionCompletionmessage
                }))
            };

            mutate(formValues, {
                onSuccess: (res) => {
                    showToast(SUCCESS, "Series Audio Created Successfully!");
                    setIsSeriesAudioAdd(false);
                    console.log("Album created", res);
                    history.push(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES);
                },
                onError: (err) => {
                    setIsSeriesAudioAdd(false);
                    console.log("Album not created", err);
                }
            });
        } catch (error) {
            console.error("Error during form submission:", error);
            setIsSeriesAudioAdd(false);
        }
    };

    // media upload on server
    const handleMediaUpload = async (file, initFile) => {
        return initializeMediaUtil(file).then(async (res) => {
            const credentials = res;
            await uploadOnS3(initFile, credentials);
            return await finalizeMediaUtil(credentials?.mediaId);
        });
    };

    return (
        <AudioSeriesForm
            mode="add"
            isLoading={isLoading || isSeriesAudioAdd}
            onAddAudio={addAudioHandler}
            isDisabled={isSeriesAudioAdd}
        />
    );
};

export default AddSeries;
